export const llmLabels = ['Model', 'Key'];
export const LLMText = 'LLM Config';
export const AddLLMTitle = 'Add LLM';
export const AddLLMDesc = 'Add LLM config to the system';
export const EditLLMTitle = 'Edit LLM';
export const EditLLMDesc = 'Manage LLM config to the system';
export const LLMTableLabels = ['PROVIDER', 'MODEL NAME', 'API KEY', 'DESCRIPTION', 'ACTIONS'];
export const AddApiKeyText = 'Add API key ';
export const AddProviderText = 'Add provider ';
export const ProviderText = 'Provider';
export const ModelNameText = 'Model name ';
export const DescriptionText = 'Description ';
export const AddProviderTitle = 'Add Provider';
export const AddProviderDesc = 'Add provider to the system';
export const ProviderNameText = 'Provider Name';
/** Allowed provider names when adding a provider (must match backend expectations). */
export const PROVIDER_SELECT_OPTIONS = ['Openai', 'Google', 'Anthropic'] as const;
export const ProviderKeyText = 'Provider API key';
export const PromptCostText = 'Prompt token cost (per million token)';
export const ResponseCostText = 'Response token cost (per million token)';
